import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import * as React from "react";
import Divider from "@mui/material/Divider";
import { Buttons } from "./Buttons";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

export const SimpleDialogComponent = (props) => {
  const {
    modalName,
    open,
    child,
    setPushData,
    handleClose,
    buttonEnviar = true,
    maxWidth = "md",
    fullscreen = false,
  } = props;

  const isMobile = props.isMobileDevice ? false : true;

  const handleOnClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      handleClose();
    }
  };

  return (
    <Dialog
      fullScreen={fullscreen}
      open={open}
      onClose={handleOnClose}
      fullWidth={isMobile}
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0 8px 32px rgba(60,75,100,0.18)",
        },
      }}
    >
      {/* Header — el background lo maneja el tema via MuiDialogTitle styleOverrides */}
      <DialogTitle sx={{ py: 1.5, px: 2.5, m: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography
            variant="subtitle1"
            sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.4, fontSize: "0.95rem" }}
          >
            {modalName}
          </Typography>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              color: "rgba(255,255,255,0.6)",
              "&:hover": { color: "#fff", bgcolor: "rgba(255,255,255,0.12)" },
            }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 2.5 }}>
        {child}
      </DialogContent>

      {buttonEnviar && (
        <>
          <Divider />
          <DialogActions sx={{ px: 2.5, py: 1.5 }}>
            <Buttons
              onClickSubmit={() => {
                setPushData();
                handleClose();
              }}
              labelButtonSave={"Guardar"}
              buttonCerrar={handleClose}
            />
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
